import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RecipeListComponent } from "./recipe-list/recipe-list.component";
import { RecipeDetailsComponent } from "./recipe-details/recipe-details.component";
import { PromoteComponent } from "./promote/promote.component";
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { ShellComponent } from './shell/shell.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { Co2eInfoComponent } from "./co2e-info/co2e-info.component";

const routes: Routes = [
  {
    path: "",
    component: SplashScreenComponent
  },
  {
    path: "promote",
    component: PromoteComponent,
  },
  {
    path: "disclaimer",
    component: DisclaimerComponent
  },
  {
    path: "home",
    component: ShellComponent,
    children: [
      {
        path: "",
        component: RecipeListComponent,
      },
      {
        path: "recipe/:recipeId",
        component: RecipeDetailsComponent,
      },
      {
        path: "co2e-info",
        component: Co2eInfoComponent
      },
    ]
  },
  //{ path: "**", redirectTo: "promote" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
